import { CmpHeader } from "../../molcules/Header";
import * as S from "./cmpTemplates.styles";

interface MainProps {
  pageTitle?: string;
  children: React.ReactElement;
}

export const CmpTemplates = ({ pageTitle, children }: MainProps) => {
  return (
    <S.MainTemplates>
      <CmpHeader pageTitle={pageTitle} />
      <S.ContentsSection>{children}</S.ContentsSection>
    </S.MainTemplates>
  );
};
